import { render, staticRenderFns } from "./CommercialCoverTypeSelection.vue?vue&type=template&id=849760b8&scoped=true"
import script from "./CommercialCoverTypeSelection.vue?vue&type=script&lang=js"
export * from "./CommercialCoverTypeSelection.vue?vue&type=script&lang=js"
import style0 from "./CommercialCoverTypeSelection.vue?vue&type=style&index=0&id=849760b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "849760b8",
  null
  
)

export default component.exports